import React from 'react';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import {
  cellRenderer,
  textMatcher,
} from '../../../../../SharedModules/utilities/utilities';

// For the proper sorting of quarter columns
const comparatorQtr = (a, b) => {
  const splittedQtrA = a.split('Q');
  const splittedQtrB = b.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};

export const TableHead = [
  {
    headerName: 'Quarter',
    field: 'quarter',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_125,
    comparator: comparatorQtr,
    cellRenderer: 'StartQtrTextbox',
    cellEditorParams: {
      maxLength: 6,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Rebate Amount',
    field: 'rebate_amt',
    // valueFormatter: dollarFormatter,
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_180,
    cellRenderer,
    cellEditorParams: {
      maxLength: 6,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'endsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcher,
    },
    isAmount: true,
    exportZeroesTwo: true,
    alignment: 'right',
    isTextColorRed: true,
    printPrefixValue: '$',
    // comparator,
  },
  {
    headerName: 'Rebate Offset Amount',
    field: 'numOfRebateOffsetAmtUnits',
    // valueFormatter: dollarFormatter,
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_180,
    cellRenderer,
    cellEditorParams: {
      maxLength: 10,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcher,
    },
    isAmount: true,
    exportZeroesTwo: true,
    isTextColorRed: true,
    alignment: 'right',
    printPrefixValue: '$',
    // comparator,
  },
  {
    headerName: 'Rebate Less Offset',
    field: 'rebate_less_offset',
    // valueFormatter: dollarFormatter,
    editable: false,
    suppressMenu: false,
    sortable: true,
    // resizable: false,
    minWidth: Styles.Width_180,
    cellRenderer,
    cellEditorParams: {
      maxLength: 10,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcher,
    },
    isAmount: true,
    exportZeroesTwo: true,
    alignment: 'right',
    isTextColorRed: true,
    printPrefixValue: '$',
    // comparator,
  },
  {
    headerName: 'Reimbursement Amount',
    field: 'reimbursement_amt',
    // valueFormatter: dollarFormatter,
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_180,
    cellRenderer,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcher,
    },
    isAmount: true,
    exportZeroesTwo: true,
    alignment: 'right',
    isTextColorRed: true,
    printPrefixValue: '$',
    // comparator,
  },
  {
    headerName: 'Percent',
    field: 'percent',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    // comparator,
    alignment: 'right',
    isTextColorRed: true,
    printPostfixValue: '%',
  },
];

export const ManufactureTableHead = [
  {
    headerName: 'Select',
    // minWidth: Styles.Width_50,
    filter: false,
    checkboxSelection: true, // For rows checkbox
    headerCheckboxSelection: false, // For header check box
    // field: "checkSelect",
    editable: false,
    suppressMenu: false,
    sortable: false,
    maxWidth: 135,
    cellStyle: { borderRightColor: Styles.BorderColor },
    // maxWidth: Styles.Width_150,
    // cellRenderer: "GenericCodeTextBox",
    // cellEditorParams: {
    //   maxLength: 5,
    //   custWidth: "135px",
    // },
    // custClass: "tbill-rate-editable-input",
    pdfExportOptions: {
      skipColumn: true,
    },
    // filter: 'agTextColumnFilter',
    // filterParams: {
    //   defaultOption: 'startsWith',
    //   suppressAndOrCondition: true,
    //   buttons: ['reset'],
    //   refreshValuesOnOpen: true,
    // },
  },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    suppressMenu: false,
    sortable: true,

    minWidth: Styles.Width_150,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
